module.exports = __webpack_public_path__ + "media/images/rating_beginner-1045e9ebc18197c79994853fc6378dc0.png";